/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   location utilities
 */

import { getQueryBounds } from '@zcode/nr-utils'

/**
 * extract the box information from location bizo
 *
 * @param location
 */
const getBoxJS = (location) => {
  const { box } = location
  const type = typeof box

  if (!box || type === 'undefined') {
    return null
  } else if (type === 'string') {
    return getQueryBounds(box)
  } else if (type === 'object') {
    return box
  }
  return null
}

export default getBoxJS
